(function($, once, Drupal) {
  Drupal.behaviors.carousel = {
    attach(context) {

      // Gets the slide positions and the index of the closest position to 0
      function getPositions($slides) {
        const positions = [];
        for (const slide of $slides.children()) {
          const position = $(slide).position().left;
          positions.push(position);
        }
        let min = Math.abs(positions[0]);
        let minIndex = 0;
        for (let i = 1; i < positions.length; i++) {
          const absolutePosition = Math.abs(positions[i]);
          if (absolutePosition < min) {
            min = absolutePosition;
            minIndex = i;
          }
        }
        return {positions, minIndex};
      }

      // Gets Nth slide relative to the slide given
      function getNthPosition({positions, minIndex, offset, visableSlides}) {
        const maxSlide = positions.length - visableSlides + 1;
        let currentIndex = minIndex;
        let newIndex = currentIndex + offset;
        newIndex = newIndex % maxSlide;
        newIndex = newIndex < 0 ? maxSlide + newIndex : newIndex;
        return positions[newIndex];
      }

      // Animates to relative target
      function animateTo({ targetPosition, $slides }) {
        const newScrollPosition = $slides.scrollLeft() + targetPosition - 2;
        $slides.animate(
          {scrollLeft: newScrollPosition},
          {easing: 'swing', duration: 300},
        );
      }

      // Click event handler to move the slides
      function moveSlides({ offset }) {
        const mobileBreakPoint = 720;
        const $document = $(document);
        return function (event) {
            const $slides = $(event.currentTarget).parent().parent().find('.slides');
            // The number of fully visable slides
            const visableSlides = $document.innerWidth() < mobileBreakPoint ? 1 : 3;
            const positions = getPositions($slides);
            const targetPosition = getNthPosition({...positions, offset, visableSlides});
            animateTo({targetPosition, $slides});
          }
      }

      // Using drupal once to ensure single atachment of event handlers
      const prevArrow = once(
        'move-slide',
        '[data-component-id="nuplayer:carousel"]>.arrows>.prev-arrow',
        context,
      );
      if (prevArrow.length > 0) {
        $(prevArrow).on('click', moveSlides({ offset: -1 }));
      }
      const nextArrow = once(
        'move-slide',
        '[data-component-id="nuplayer:carousel"]>.arrows>.next-arrow',
        context,
      );
      if (nextArrow.length > 0) {
        $(nextArrow).on('click', moveSlides({ offset: 1 }));
      }
    }
  };
})(jQuery, once, Drupal);
